import type { Message } from "../types/Message";
import type { MessageSenderRole } from "../types/Roles";

type FormattableIncomingMessage = {
    text: string;
    senderName: string;
    hasQuickRequest: boolean;
    attachments: { mimeType: string | null; fileName: string | null }[];
};

export function formatMessageToString(message: FormattableIncomingMessage) {
    if (message.text) {
        return message.text;
    }

    const attachment =
        message.attachments && message.attachments.length === 1
            ? message.attachments[0]
            : undefined;

    if (attachment) {
        if (attachment.mimeType?.startsWith("image")) return `Photo message received.`;
        if (attachment.mimeType?.startsWith("audio")) return `Audio message received.`;
        return `Attachment received: ${attachment.fileName}`;
    }
    if (message.attachments && message.attachments.length > 1) {
        return `Attachments (${message.attachments.length}) received.`;
    }
    if (message.hasQuickRequest) {
        return `${message.senderName} sent a quick request.`;
    }
    return "New message received!";
}

export function getSenderRole(message: Message): MessageSenderRole {
    return message.sentByAgent ? "agent" : "member";
}
